import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import { getOnboardingUrl } from '../../../utils/portalUrl';
import styles from './BizCategories.module.css';

import BarberPhoto   from '../../../assets/Industry_Barber_Software_Fresha.05bb918e.jpg';
import SalonPhoto    from '../../../assets/Industry_Salon_Software_Fresha.e60d3dd6.jpg';
import NailsPhoto    from '../../../assets/Industry_Nails_Software_Fresha.46347c46.jpg';
import DentalPhoto   from '../../../assets/Industry_dental.jpg';
import ClinicsPhoto  from '../../../assets/clinic-aest.jpeg';
import MassagePhoto  from '../../../assets/Industry_Massage_Software_Fresha.be6af04f.jpg';
import BeautyPhoto   from '../../../assets/beauty_center.jpeg';
import SpaPhoto      from '../../../assets/Industry_Spa_Software_Fresha.b66df7eb.jpg';
import MedSpaPhoto   from '../../../assets/Industry_MedSpa_Software_Fresha.0afc4a22.jpg';
import PetPhoto      from '../../../assets/Industry_PET_Software_Fresha.6ff140cf.jpg';
import FitnessPhoto  from '../../../assets/Industry_Fitness_Software_Fresha.beeb275f.jpg';
import TanningPhoto  from '../../../assets/Industry_Tanning_One-Solution_Fresha.cab9793e.jpg';
import TattooPhoto   from '../../../assets/Industry_Tattoo-Piercing_Software_Fresha.d4736b77.jpg';
import OnlinePhoto   from '../../../assets/Industry_Salon_Fresha_software_you_can_trust.239a423b.jpg';

const BIZ_ITEMS = [
  { key: 'barber',  path: '/for/barber-shops', photo: BarberPhoto  },
  { key: 'hair',    path: '/for/hair-salons',  photo: SalonPhoto   },
  { key: 'nails',   path: '/for/nail-salons',  photo: NailsPhoto   },
  { key: 'dental',  path: '/for/dental',       photo: DentalPhoto  },
  { key: 'clinics', path: '/for/clinics',      photo: ClinicsPhoto },
  { key: 'massage', path: '/for/massage',      photo: MassagePhoto },
  { key: 'beauty',  path: '/for/beauty',       photo: BeautyPhoto  },
  { key: 'spa',     path: '/for/spa',          photo: SpaPhoto     },
  { key: 'medspa',  path: '/for/med-spa',      photo: MedSpaPhoto  },
  { key: 'pet',     path: '/for/pet-grooming', photo: PetPhoto     },
  { key: 'fitness', path: '/for/fitness',      photo: FitnessPhoto },
  { key: 'tanning', path: '/for/tanning',      photo: TanningPhoto },
  { key: 'tattoo',  path: '/for/tattoo',       photo: TattooPhoto  },
  { key: 'online',  path: '/for/online',       photo: OnlinePhoto  },
];

const BizCategories = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <h2 data-aos="fade-up">{t('home.bizSection.title')}</h2>
          <p data-aos="fade-up" data-aos-delay="60">{t('home.bizSection.subtitle')}</p>
          <a
            href={getOnboardingUrl("biz_section")}
            className={styles.ctaBtn}
            data-aos="fade-up"
            data-aos-delay="120"
          >
            <FaArrowLeft className={styles.ctaArrow} />
            {t('nav.startNow')}
          </a>
        </div>

        <div className={styles.grid}>
          {BIZ_ITEMS.map(({ key, path, photo, Icon, color }, i) => {
            const label = t(`businesses.cards.${key}.title`);
            if (photo) {
              return (
                <Link to={path} key={key} className={styles.card}
                  data-aos="fade-up" data-aos-delay={Math.min(i * 30, 150)}>
                  <img src={photo} alt={label} className={styles.img} />
                  <div className={styles.overlay} />
                  <span className={styles.label}>{label}</span>
                </Link>
              );
            }
            return (
              <Link to={path} key={key} className={`${styles.card} ${styles.fallback}`}
                style={{ background: `linear-gradient(135deg, ${color}dd, ${color}99)` }}
                data-aos="fade-up" data-aos-delay={Math.min(i * 30, 150)}>
                {Icon && <Icon className={styles.fallbackIcon} />}
                <span className={styles.label}>{label}</span>
              </Link>
            );
          })}
        </div>

        <div className={styles.footer} data-aos="fade-up">
          <Link to="/for" className={styles.viewAll}>
            {t('home.bizSection.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BizCategories;
